import {IOptionItemChoice, IUserSelection, IUserSelections} from "@bimaire/optionslib";
import UnrealOptionTransformation from "./UnrealOptionTransformation";
import {IVisualizerManager} from "../visualizers/VisualizerContext";
import VisualizerSessionManager from "../components/visualizer/VisualizerSessionManager";


async function sendOptionToUnreal(endpoint: string, unrealOption: string) {
  const body = "value=" + encodeURIComponent(unrealOption).replace(/%20/g, "+");
  return await fetch(endpoint, { method: "POST", body: body });
}
export interface IOptionSetRequest {
  lot?: string;
  options: {
    [key: string]: {
      OptionSelection: string;
      OptionType: 1 | 2;
      OptionValue: string;
    };
  };
}
type OptionTypeStructural = 1;
type OptionTypeMaterial = 2;

function getOptionRequestElement(unrealOpt: string): {
  OptionType: OptionTypeMaterial | OptionTypeStructural;
  OptionSelection: string;
  OptionValue: string;
} {
  if (unrealOpt.startsWith("#")) {
    const unrealOptWithoutPrefix = unrealOpt.substring(1);

    const [materialOptSel, materialOptVal] = unrealOptWithoutPrefix.split(":");
    return {
      OptionType: 2 as OptionTypeMaterial,
      OptionSelection: materialOptSel,
      OptionValue: materialOptVal,
    };
  }
  const req = {
    OptionType: 1 as OptionTypeStructural,
    OptionSelection: unrealOpt,
    OptionValue: "",
  };
  return req;
}
function getOptionRequest(unrealOptions: string[], lot?: string) {
  const optionRequest: IOptionSetRequest = {
    options: {}
  };
  if (lot !== undefined) {
    optionRequest.lot = lot;
  }

  let idx = 1;
  for (const unrealOpt of unrealOptions) {
    const req = getOptionRequestElement(unrealOpt);
    optionRequest.options[`opt${idx++}`] = req;
  }
  return optionRequest;
}
class UnrealClient {
  // What options are active in the Unreal model
  private options: string[] = [];
  private readonly transformations: UnrealOptionTransformation[];

  constructor(
      private readonly unrealVisualizer: VisualizerSessionManager,

      private readonly configuration: string
  ) {
    const configStrings = configuration
        .split("\n")
        .filter((c) => c.trim().length > 0 && !c.startsWith("//"));
    this.transformations = configStrings.map((c) =>
        UnrealOptionTransformation.fromConfigString(c.trim())
    );
  }


  async updateDisclaimerLabel(label: string, coords: [number, number]) {


    const req = {
      textmanager: {
        action: "show",
        id: "disclaimer",
        text: label,
        location: `(x=${coords[0]},y=${coords[1]})`,
        color: "(r=1,g=1,b=1,a=1)",
        "background color": "(r=0,g=0,b=0,a=0.6)",
        size: 16
      }


    };

    return; // TODO
    /*return fetch(this.endpoint + "/TextOnScreen", {
      method: "POST",
      body: JSON.stringify(req),
    });*/
  }

  updateOptionLabel(label: string) {

    const req = {
      textmanager: {
        action: "show",
        id: "style",
        text: label,
        location: "(x=10,y=40)",
        color: "(r=1,g=1,b=1,a=1)",
        "background color": "(r=0,g=0,b=0,a=0.6)",

        size: 48
      }

    };
    return; /*
    return fetch(this.endpoint + "/TextOnScreen", {
      method: "POST",
      body: JSON.stringify(req),
    });
*/
  }

  private sendOptions(unrealOptions: string[], lot:string) {
    const req = getOptionRequest(unrealOptions, lot);
    this.unrealVisualizer.sendOptions(req);

  }



  async updateOptions(userSelections: IOptionItemChoice[], lot:string) {
    console.log("sent options");
    console.log(userSelections);
    const unrealOptions: string[] = [];
    for (const userSelection of userSelections) {
      for (const transformation of this.transformations) {
        const opt = transformation.processSelection(userSelection);
        if (opt !== null) {
          unrealOptions.push(opt);
        }
      }
    }
    // TODO push the option
    console.log(unrealOptions);
    await this.sendOptions(unrealOptions, lot);


  }

  async setCamera(cameraId: string) {
    return this.unrealVisualizer.changeCamera(cameraId);

  }
}

export default UnrealClient;
